import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/preload.min.css";
import "../css/icomoon.css";
import "../css/about.min.css";
import "../css/index.min.css";
import default_banner from "../img/golf-image.jpg";
import "../scss/custom.scss";
import logo from "../img/loho.png";
import axios from "axios";
import CountdownTimer from "../components/CountdownBanner";
import { getPricingInfo } from "../utils/pricingUtils";
import gold from "../img/gold.png";

const Home = () => {
  const [teams, setTeams] = useState([]);
  const pricing = getPricingInfo();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const response = await axios.get(
        "https://ihm-golf-tournament-spreadsheet.vercel.app/teams",
      );
      if (response.data) {
        setTeams(response.data);
        console.log(response.data);
      } else {
        console.log("No data found.");
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Sticky Menu Area
  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  });

  const mappedArray = teams.map((innerArray) => {
    return (
      <tr>
        {innerArray.map((value, index) => {
          if (index !== 1 && index !== 6) {
            return <td key={index}>{value}</td>;
          }
          return null;
        })}
      </tr>
    );
  });

  /* Method that will fix header after a specific scrollable */
  const isSticky = (e) => {
    const header = document.querySelector(".headroom");
    const scrollTop = window.scrollY;
    if (header) {
      scrollTop >= 250
        ? header.classList.add("is-sticky")
        : header.classList.remove("is-sticky");
    }
  };
  return (
    <>
      {/*<Header nav="false" />*/}
      {/* homepage content start */}
      <main>
        <div className="">
          <CountdownTimer />
        </div>
        {/* hero section start */}
        <div className="hero-container">
          <div className="overlay">
            <picture>
              <source data-srcset={default_banner} srcSet={default_banner} />
              <img
                className="lazy"
                data-src={default_banner}
                src={default_banner}
                alt="media"
              />
              <div className="overlay"></div>
            </picture>
          </div>
          <section className="hero section">
            <div className="container container--hero d-lg-flex align-items-center justify-content-center">
              <div className="">
                <img
                  className="banner-logo"
                  src={logo}
                  alt="IHM GOLF TOURNAMENT"
                ></img>
                <h1>
                  <span className="subtitle">Immaculate Heart of Mary</span>
                  <br /> Golf Tournament
                </h1>
                <p>
                  <i className="icon-location"></i> THE PONDS GOLF COURSE
                </p>
                <div className="hero_main-content center">
                  {/*<span className="line"></span> 
                <p className="text">
                  Sign up and pay below
                </p>
                */}
                </div>
                {/*<div className="item-wrapper d-sm-flex flex-wrap flex-lg-nowrap justify-content-center align-items-lg-center">
                <a className="btn theme-element theme-element--accent m-1" type="submit" href="tel:763-434-3686">
                  SIGN UP AND PAY
                </a>
              </div>*/}
              </div>
            </div>
          </section>
        </div>
        <div className="main-content">
          <section className="section dark primary-bg main">
            <div className="container">
              <div className="row">
                <div
                  className="col-lg-7"
                  data-aos="fade-right"
                  data-aos-delay="100"
                >
                  <h2 className="primary-c">
                    JOIN US FOR OUR GOLF TOURNAMENT FUNDRAISER.
                  </h2>
                </div>
                <div
                  className="col-lg-4"
                  data-aos="fade-left"
                  data-aos-delay="200"
                >
                  <div className="date-time">
                    <h2>31 MAY</h2>
                    <h3 className="mb-0">SUNDAY AT 1PM</h3>
                    <p className="mt-0">
                      <i>Check in at noon</i>
                    </p>
                  </div>
                </div>
                <div
                  className="col-lg-7"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  <p>
                    Brought to you by the Holy Name Society. All proceeds
                    benefit IHM Academy.
                  </p>
                  <p>
                    <ul data-aos="fade-up" data-aos-delay="400">
                      <li data-aos="fade-left" data-aos-delay="500">
                        4 Person per Team Scramble
                      </li>
                      <li data-aos="fade-left" data-aos-delay="600">
                        <strong className="primary-c large">$1000</strong> goes
                        to the winning team
                      </li>
                      <li data-aos="fade-left" data-aos-delay="700">
                        Side games, such as longest drive, will be offered the
                        day of the event.
                      </li>
                      <li data-aos="fade-left" data-aos-delay="800">
                        Hole in One challenge to win{" "}
                        <span className="primary-c">$2000 worth of GOLD</span>
                      </li>
                    </ul>
                  </p>
                  <div className="atv" data-aos="zoom-in" data-aos-delay="400">
                    <img data-src={gold} src={gold} alt="media" />
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* contacts section end */}
          <section
            className="section price-and-registration pb-0 mb-5"
            data-aos="fade-left"
          >
            <div className="container">
              <div className="row">
                <div className="col-lg-6">
                  <h1 className="primary-c">
                    {pricing.isEarlyBird ? (
                      <>
                        <span
                          style={{
                            textDecoration: "line-through",
                            marginRight: "15px",
                            opacity: "0.9",
                            textDecorationColor: "black",
                          }}
                        >
                          ${pricing.regularPrice}.00
                        </span>
                        ${pricing.earlyBirdPrice}.00
                      </>
                    ) : (
                      `$${pricing.currentPrice}.00`
                    )}
                    <span className="small">/ Golfer</span>
                  </h1>
                  {pricing.isEarlyBird && (
                    <p>
                      <strong>
                        Early Bird Special - Sign up before April 30th and save
                        $15!
                      </strong>
                    </p>
                  )}
                  <p>
                    <strong>
                      Includes 18 holes, cart, meal, and tickets for door prizes
                    </strong>
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section className="section pb-0 pt-0">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-4 team" data-aos="fade-up">
                  <a href="/team">
                    <div className="box-container">
                      <div className="center">
                        <span className="subtitle">LET'S WIN THIS</span>
                        <h3>Register Your Team</h3>
                        <span className="block-link">Register now</span>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-lg-4 individual" data-aos="fade-up">
                  <a href="/individual-sign-up">
                    <div className="box-container">
                      <div className="center">
                        <span className="subtitle">JOIN A TEAM</span>
                        <h3>Register as an Individual</h3>
                        <span className="block-link">Register now</span>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-lg-4 business" data-aos="fade-up">
                  <a href="/business">
                    <div className="box-container">
                      <div className="center">
                        <span className="subtitle">
                          GIVE YOUR BUSINESS A SHOUT OUT
                        </span>
                        <h3>Become a Sponsor</h3>
                        <span className="block-link">Sponsor now</span>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </section>
          {/* hero section end */}
          {/* rooms section start */}

          {teams.length > 0 && (
            <section className="section neutral-bg" data-aos="fade-up">
              <div className="container">
                <h3 className="mb-4" data-aos="fade-right" data-aos-delay="100">
                  Teams Registered
                </h3>
                <p data-aos="fade-right" data-aos-delay="200">
                  Teams listed have been confirmed.
                </p>
                <div
                  className="table-wrapper"
                  data-aos="fade-up"
                  data-aos-delay="300"
                >
                  {teams.length > 0 ? (
                    <table>
                      <thead>
                        <tr>
                          <th>Team Name</th>
                          <th>Player 1</th>
                          <th>Player 2</th>
                          <th>Player 3</th>
                          <th>Player 4</th>
                        </tr>
                      </thead>
                      <tbody>{mappedArray}</tbody>
                    </table>
                  ) : (
                    <div className="pulsating-square"></div>
                  )}
                </div>
                <p className="sm-p mt-3 mobile">Swipe right to view more.</p>
              </div>
            </section>
          )}
          <section className="section pb-5">
            <div className="container">
              <div className="row">
                <div
                  className="col-lg-6"
                  data-aos="fade-in"
                  data-aos-delay="100"
                >
                  <p>
                    <strong style={{ fontSize: "20px" }}>
                      For more information, contact:
                    </strong>{" "}
                    <br />
                    <a href="mailto:ihmgolftournament@gmail.com">
                      ihmgolftournament@gmail.com
                    </a>
                  </p>
                </div>
                <div
                  className="col-lg-6 mt-4 mt-lg-0"
                  data-aos="fade-in"
                  data-aos-delay="200"
                >
                  <p>
                    <strong style={{ fontSize: "20px" }}>
                      Location and address:
                    </strong>{" "}
                    <br />
                    The Ponds Golf Course <br />
                    2881 229th Ave NW, <br />
                    St Francis, MN 55070
                  </p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
      {/* homepage content end */}

      {/*<GoogleReviews placeId={placeId} />*/}
      <footer className="footer accent">
        <div className="container">
          <div className="footer_copyright">
            <div className="container">
              <p className="footer_copyright-text">
                <span className="linebreak">
                  Made by Up North Creative
                  <br />
                </span>
                <span className="linebreak">All rights reserved © 2026</span>
              </p>
            </div>
          </div>
        </div>
      </footer>
      {/**/}
    </>
  );
};

export default Home;
